import { useState } from 'react';

export const usePagination = (data, initialItemsPerPage = 10, initialPage = 1) => {
    const [internalCurrentPage, setInternalCurrentPage] = useState(initialPage);
    const [internalItemsPerPage, setInternalItemsPerPage] = useState(initialItemsPerPage);

    // Treat the provided values as initial defaults and use internal state
    // for pagination so callers can navigate pages normally.
    const currentPage = internalCurrentPage;
    const itemsPerPage = internalItemsPerPage;

    const setCurrentPage = page => setInternalCurrentPage(page);
    const setItemsPerPage = size => setInternalItemsPerPage(size);

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentData = data.slice(startIndex, endIndex);
    const goToPage = pageNumber => {
        const newPage = Math.max(1, Math.min(pageNumber, totalPages));
        setCurrentPage(newPage);
    };

    const goToFirstPage = () => setCurrentPage(1);
    const goToLastPage = () => setCurrentPage(totalPages);
    const goToPreviousPage = () => setCurrentPage(Math.max(1, currentPage - 1));
    const goToNextPage = () => setCurrentPage(Math.min(totalPages, currentPage + 1));

    const changePageSize = newPageSize => {
        setItemsPerPage(newPageSize);
        setCurrentPage(1); // Reset to first page
    };

    return {
        currentData,
        currentPage,
        totalPages,
        itemsPerPage,
        startIndex,
        endIndex: Math.min(endIndex, data.length),
        totalItems: data.length,
        goToPage,
        goToFirstPage,
        goToLastPage,
        goToPreviousPage,
        goToNextPage,
        changePageSize,
    };
};
